import { containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, downloadFileHandler, request } from "services/request";

const resource = "api/trailer";
const trailersQuery = { orderBy: "id desc" };

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...trailersQuery });
    return request(`${resource}/getlist${query}&withDeleted=true`, { method: "GET" }, { countInHeaders: true });
};

const getListExcel = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...trailersQuery });
    return request(
        `${resource}/getListExcel?${query}&withDeleted=true`,
        { method: "GET" },
        { withoutMiddleware: true },
    ).then((res) => downloadFileHandler(res, "Прицепы.xlsx"));
};

const list = (params: {}) => request(`${resource}/getlist${containsQuery(params)}`, { method: "GET" });

const numbersList = (params: {}) => request(`${resource}/getNumbersList${containsQuery(params)}`, { method: "GET" });

const filteredNumbersList = (params: {}, ids: number[]) =>
    request(`${resource}/getNumbersList${containsQuery(params, { filter: { id: { in: ids } } })}`, { method: "GET" });

const getAvailabilityStatus = (id: number) => request(`${resource}/getAvailabilityStatus/${id}`, { method: "GET" });

const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));

const getItem = (params: { id: number }) => request(`${resource}/getForEdit?id=${params.id}`, { method: "GET" });

const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));

const setResourceActivity = (params: {}) => alertRequest(`${resource}/setResourceActivity`, body(params));

const restore = (params: {}) => alertRequest(`${resource}/restore`, body(params));

const addTrailersToRefuelingSyncList = (params: {}) =>
    alertRequest(`${resource}/addTrailersToRefuelingSyncList`, body(params));

const addAllTrailersToRefuelingSyncList = () => alertRequest(`${resource}/addAllTrailersToRefuelingSyncList`, body({}));

const removeTrailersFromRefuelingSyncList = (params: {}) =>
    alertRequest(`${resource}/removeTrailersFromRefuelingSyncList`, body(params));

const removeAllTrailersFromRefuelingSyncList = () =>
    alertRequest(`${resource}/removeAllTrailersFromRefuelingSyncList`, body({}));

const getFuelInfoForRefuelPlanning = (id?: number) => {
    if (!id) {
        return Promise.resolve();
    }
    return request(`${resource}/getFuelInfoForRefuelPlanning?id=${id}`, { method: "GET" }).then((data) => {
        if (data) {
            data.fuelTanks.forEach((item: { relationType: string }) => {
                item.relationType = "Trailer";
            });
        }
        return data;
    });
};

export {
    index,
    apply,
    getItem,
    delItem,
    list,
    numbersList,
    getAvailabilityStatus,
    setResourceActivity,
    restore,
    addTrailersToRefuelingSyncList,
    addAllTrailersToRefuelingSyncList,
    removeTrailersFromRefuelingSyncList,
    removeAllTrailersFromRefuelingSyncList,
    getFuelInfoForRefuelPlanning,
    getListExcel,
    filteredNumbersList,
};
